export default {
  DATA_UPLOADS: 'Data Uploads',
  DATA_UPLOADS_BACK_TO_UPLOADS: 'Back to Data Uploads',
  DATA_UPLOADS_CANCEL_ERROR:
    'There was an issue with canceling your data upload.',
  DATA_UPLOADS_FILE_UPLOAD_OTHER:
    'Error: There was a problem with your upload. Please try again',
  DATA_UPLOADS_FILE_UPLOAD_TOO_LARGE:
    'Error: File too large. Cannot exceed 500MB.',
  DATA_UPLOADS_FILE_UPLOAD_WRONG_TYPE:
    'Error: Incorrect file type. Must be a CSV file.',
  DATA_UPLOADS_FILE_UPLOAD_PROCESSING_ERROR:
    'Error: There is an issue with the CSV file. Instil is unable to process it.',
  DATA_UPLOADS_FILE_UPLOAD_IN_PROGRESS_ERROR:
    'Error: Cannot create a new upload while another upload is currently in progress',
  DATA_UPLOADS_FILE_UPLOAD_INSTRUCTIONS:
    'CSV format only. 500 MB max file size.',
  DATA_UPLOADS_HEADER_TITLE: 'Instil Header',
  DATA_UPLOADS_HIDE_EMPTY_DATA: 'Hide Empty Data',
  DATA_UPLOADS_NEW_DATA_UPLOAD: 'New Data Upload',
  DATA_UPLOADS_NEW_DATA_UPLOAD_INSTRUCTIONS_1:
    'Our goal is to provide you with an easy to use, two-step upload process to maximize control over how your data is imported. The first step is to map your data to Instil. Second, you will review and confirm prior to the final import of data into Instil.',
  DATA_UPLOADS_NEW_DATA_UPLOAD_INSTRUCTIONS_2: 'Data Uniqueness',
  DATA_UPLOADS_NEW_DATA_UPLOAD_INSTRUCTIONS_3:
    'Each row of data is considered new and unique, thus Instil will create the data. For Constituents, Instil considers emails unique. If an email already exists, the current record will be updated, otherwise a new Constituent will be created.',
  DATA_UPLOADS_NEW_DATA_UPLOAD_INSTRUCTIONS_4: 'Supported Data Types',
  DATA_UPLOADS_NEW_DATA_UPLOAD_INSTRUCTIONS_5:
    'Instil uploads currently supports Constituents, Contributions, and Campaigns.',
  DATA_UPLOADS_NEW_DATA_UPLOAD_INSTRUCTIONS_6: 'Preventing Data Duplicates',
  DATA_UPLOADS_NEW_DATA_UPLOAD_INSTRUCTIONS_7:
    'Help prevent duplicates by providing unique IDs within your file. It’s best to provide both a unique ID and data Source.',
  DATA_UPLOADS_NEW_DATA_UPLOAD_INSTRUCTIONS_8:
    'If you have any questions or concerns, please reach out to <emailLink></emailLink>',
  DATA_UPLOADS_NEW_UPLOAD: 'New Upload',
  DATA_UPLOADS_MATCH_HEADERS: 'Match Table Headers',
  DATA_UPLOADS_MATCH_HEADERS_ERROR:
    'There was an issue with processing your CSV',
  DATA_UPLOADS_MATCH_HEADERS_INSTRUCTIONS_1:
    "Use the match functionality to connect the column's data with the corresponding Instil Header. Tooltips provide hints about Instil fields. Unmatched columns will be skipped when importing.",
  DATA_UPLOADS_MATCH_HEADERS_INSTRUCTIONS_2:
    'Once you hit submit, we’ll give you an overview of the data along with any errors that arise. You will have an opportunity to review before the data comes into Instil.',
  DATA_UPLOADS_MATCH_HEADERS_TOTAL_MATCHED:
    '{matched} of {total} {total, plural, one {Header} other {Headers}} matched',
  DATA_UPLOADS_MATCH_HEADERS_SUBMIT_DISABLED_MESSAGE:
    'You must match at least one table header to submit an upload for review',
  DATA_UPLOADS_MATCH_HEADERS_CUSTOM_FIELD: 'This is a custom field.',
  DATA_UPLOADS_ROW_NUM: 'Row {num}',
  DATA_UPLOADS_SUBMIT_FOR_REVIEW: 'Submit for Review',
  DATA_UPLOADS_CANCEL_UPLOAD: 'Cancel Upload',
  DATA_UPLOADS_NO_COLUMN_DATA: 'This column has no data.',
  DATA_UPLOADS_TOTAL: 'Total',
  DATA_UPLOADS_ERRORS_LABEL: 'Errors',
  DATA_UPLOADS_STATUS: 'Status',
  DATA_UPLOADS_FILE_NAME: 'File Name',
  DATA_UPLOADS_TEAM_MEMBER: 'Team Member',
  DATA_UPLOADS_STATUS_GENERATING_REVIEW: 'Generating review',
  DATA_UPLOADS_STATUS_PROCESSING: 'Processing',
  DATA_UPLOADS_STATUS_COMPLETED: 'Completed',
  DATA_UPLOADS_STATUS_EXPIRED: 'Expired',
  DATA_UPLOADS_STATUS_CANCELED: 'Canceled',
  DATA_UPLOADS_STATUS_REVERT: 'Revert',
  DATA_UPLOADS_STATUS_REVERTING: 'Reverting',
  DATA_UPLOADS_STATUS_REVERTED: 'Reverted',
  DATA_UPLOADS_STATUS_READY_FOR_REVIEW: 'Ready for review',
  DATA_UPLOADS_STATUS_MATCH_HEADERS: 'Match Headers',
  DATA_UPLOADS_TOOLTIP_AMOUNT: 'Must be equal to or greater than 1.00',
  DATA_UPLOADS_TOOLTIP_AMOUNT_OF_TIME:
    'Assumed Hours unless otherwise specified.',
  DATA_UPLOADS_TOOLTIP_ASSIGNEE: "This is the employee's email in Instil.",
  DATA_UPLOADS_TOOLTIP_CATEGORY:
    'For All Constituents: Board Member, Client, Member, Partner, Volunteer<br></br>Only for Organizations: Corporation, Foundation, Government',
  DATA_UPLOADS_TOOLTIP_DATE: 'Assumed date of upload unless provided.',
  DATA_UPLOADS_TOOLTIP_DOB: 'MM/DD/YY',
  DATA_UPLOADS_TOOLTIP_EMAIL:
    'If the email already exists in system, we will update the record. Otherwise, we will create a new record.',
  DATA_UPLOADS_TOOLTIP_FREQUENCY:
    'Assumed Monthly if value is not provided. Accepted Cadences:<br></br>Daily, Weekly, Bi-weekly, Monthly, Quarterly, Semi-Annually, Yearly',
  DATA_UPLOADS_TOOLTIP_CONSTITUENT_ID:
    'This is a unique identifier assigned to individuals and organizations to prevent duplicate data entries.',
  DATA_UPLOADS_TOOLTIP_CAMPAIGN_ID:
    'This is a unique identifier assigned to campaigns to prevent duplicate data entries.',
  DATA_UPLOADS_TOOLTIP_CONTRIBUTION_ID:
    'This is a unique identifier assigned to contributions to prevent duplicate data entries.',
  DATA_UPLOADS_TOOLTIP_LABEL: 'Comma separated for multiple values.',
  DATA_UPLOADS_TOOLTIP_PHONE_NUMBER: 'Must be a complete phone number.',
  DATA_UPLOADS_TOOLTIP_QUANTITY: 'Assumed 1 unless numerical value provided.',
  DATA_UPLOADS_TOOLTIP_SOFT_CREDIT: 'This must be an email address to create.',
  DATA_UPLOADS_TOOLTIP_SOURCE:
    'This is where the data originated from. Providing Source and ID are the best approach to prevent data duplicates.',
  DATA_UPLOADS_NO_DATA_UPLOADS: 'No Data Uploads',
  DATA_UPLOADS_IMPORT_YOUR_ORGS_DATA:
    "Import your organization's data by beginning a new upload",
  DATA_UPLOADS_DESTROY_ALL_DATA: 'Destroy all data',
  DATA_UPLOADS_DESTROY_ALL_DATA_MESSAGE:
    'You are about to remove all data uploaded to {orgName} within the past 12 hours. <warn>There is no way to undo this action.</warn> Are you sure you want to continue?',
  DATA_UPLOADS_CANCEL_DATA_UPLOAD: 'Cancel data upload',
  DATA_UPLOADS_REVIEW: 'Data Upload Review',
  DATA_UPLOADS_CANCEL_DATA_UPLOAD_MESSAGE:
    'Canceling the upload will stop all processes. After canceling, you will need to resubmit the file and start over.',
  DATA_UPLOADS_DATA_OVERVIEW: 'Data Overview',
  DATA_UPLOADS_DATA_OVERVIEW_MESSAGE:
    'We have finished a review of <strong>{fileName}</strong>. Based on the data present and the column matching we see the following items ready for import:',
  DATA_UPLOADS_DATA_OVERVIEW_PROCESS_COMPLETE_MESSAGE:
    'Based on the data present, we imported the following items:',
  DATA_UPLOADS_CONSTITUENTS: 'Constituents',
  DATA_UPLOADS_SUCCESS_COUNT:
    '<div1>{numSuccess} Successful</div1> <div2>of {numTotalRows} Total Rows</div2>',
  DATA_UPLOADS_NUM_ERRORS: '{numErrors, plural, =1 {1 Error} other {# Errors}}',
  DATA_UPLOADS_NUM_SKIPPED: '{numSkipped} Skipped',
  DATA_UPLOADS_NUM_CREATED: '{numCreated} Created',
  DATA_UPLOADS_NUM_UPDATED: '{numUpdated} Updated',
  DATA_UPLOADS_ERROR_TOOLTIP: 'See summary report for details.',
  DATA_UPLOADS_SKIPPED_TOOLTIP: 'Record already exists, no actions to take.',
  DATA_UPLOADS_CONTRIBUTIONS: 'Contributions',
  DATA_UPLOADS_CAMPAIGNS: 'Campaigns',
  DATA_UPLOADS_ERROR_SUMMARY: 'Data Summary',
  DATA_UPLOADS_ERROR_SUMMARY_MESSAGE:
    'This is a  report that includes all the errors, skips, and updates identified during the import process. Any rows with errors will not be imported. Download the report by clicking on the report download link below.',
  DATA_UPLOADS_DOWNLOAD_ERROR_REPORT_CSV: 'Download Summary Report (CSV)',
  DATA_UPLOADS_REVIEW_WARNING: "Warning: Importing of data can't be undone.",
  DATA_UPLOADS_REVIEW_CONTACT:
    'If you have any questions, please contact the Instil team at <a></a>',
  DATA_UPLOADS_FINISH_IMPORT: 'Finish Import',
  DATA_UPLOADS_CANCEL_IMPORT: 'Cancel Import',
  DATA_UPLOADS_CONFIRMATION_MESSAGE:
    'Your upload has been submitted. You will receive an email once we have completed processing and importing your data.',
  DATA_UPLOADS_DISABLED_MESSAGE:
    'You may only process one file at a time. Please complete your current data upload.',
  DATA_UPLOADS_MOBILE_MESSAGE: 'This page is not optimized for mobile use.',
  DATA_UPLOADS_PREVENT_NAVIGATION_MESSAGE:
    'You have unsaved changes. If you leave the page, these changes will be lost.',
  DATA_UPLOADS_PROCESS_CANCELED:
    'Your upload has been canceled. You will need to submit a new file to begin the process again.',
  DATA_UPLOADS_PROCESS_REVERTED:
    'The request to revert your upload has been received. You will receive an email when the process is complete.',
  DATA_UPLOADS_PREVIEW: 'Preview',
  DATA_UPLOADS_PREVIEW_CSV: 'Preview CSV Data',
  DATA_UPLOADS_PREVIEW_SEARCH: 'Search CSV',

  DATA_UPLOADS_CATEGORY_CAMPAIGN: 'Campaign',
  DATA_UPLOADS_CATEGORY_CONSTITUENT: 'Constituent',
  DATA_UPLOADS_CATEGORY_CONTRIBUTION: 'Contribution',

  // START: table header dropdown
  DATA_UPLOADS_MATCH_TABLE_HEADER_ADDRESS_LINE_1: 'Street Address Line 1',
  DATA_UPLOADS_MATCH_TABLE_HEADER_ADDRESS_LINE_2: 'Street Address Line 2',
  DATA_UPLOADS_MATCH_TABLE_HEADER_AMOUNT_TIME: 'Amount of Time',
  DATA_UPLOADS_MATCH_TABLE_HEADER_AMOUNT_TIME_TOOLTIP:
    'For gifts of time, in hours',
  DATA_UPLOADS_MATCH_TABLE_HEADER_ASSIGNEE: 'Assignee Email',
  DATA_UPLOADS_MATCH_TABLE_HEADER_BIO: 'Biography',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CAMPAIGN_NAME: 'Campaign Name',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CAMPAIGN_START_DATE: 'Campaign Start Date',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CAMPAIGN_DESCRIPTION: 'Campaign Description',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CATEGORY: 'Category',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CITY: 'City',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_FIRST_NAME:
    'Constituent First Name',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_LABEL: 'Constituent Label',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_LAST_NAME:
    'Constituent Last Name',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_ORG_NAME:
    'Constituent Organization Name',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CONTRIBUTION_AMOUNT: 'Contribution Amount',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CONTRIBUTION_LABEL: 'Contribution Label',
  DATA_UPLOADS_MATCH_TABLE_HEADER_COUNTRY: 'Country',
  DATA_UPLOADS_MATCH_TABLE_HEADER_DATE: 'Date',
  DATA_UPLOADS_MATCH_TABLE_HEADER_DOB: 'Birthdate',
  DATA_UPLOADS_MATCH_TABLE_HEADER_DUE_DATE: 'Pledge Due Date',
  DATA_UPLOADS_MATCH_TABLE_HEADER_DUE_DATE_TOOLTIP: 'Date Pledge Due',
  DATA_UPLOADS_MATCH_TABLE_HEADER_EARNED_REV_AMT: 'Earned Revenue',
  DATA_UPLOADS_MATCH_TABLE_HEADER_EMAIL_BIZ: 'Email Business',
  DATA_UPLOADS_MATCH_TABLE_HEADER_EMAIL_BIZ_PRIMARY: 'Email Business - Primary',
  DATA_UPLOADS_MATCH_TABLE_HEADER_EMAIL_PERSONAL: 'Email Personal',
  DATA_UPLOADS_MATCH_TABLE_HEADER_EMAIL_PERSONAL_PRIMARY:
    'Email Personal - Primary',
  DATA_UPLOADS_MATCH_TABLE_HEADER_END_DATE: 'Campaign End Date',
  DATA_UPLOADS_MATCH_TABLE_HEADER_EST_VALUE_AMT: 'Estimated Value Amount',
  DATA_UPLOADS_MATCH_TABLE_HEADER_EST_VALUE_AMT_TOOLTIP:
    'Estimated Planned Giving Amount',
  DATA_UPLOADS_MATCH_TABLE_HEADER_FACEBOOK_PROFILE: 'Facebook Profile',
  DATA_UPLOADS_MATCH_TABLE_HEADER_FAX_NUMBER: 'Phone Number Fax',
  DATA_UPLOADS_MATCH_TABLE_HEADER_FREQUENCY: 'Recurring Frequency',
  DATA_UPLOADS_MATCH_TABLE_HEADER_FULL_ADDRESS: 'Full Address',
  DATA_UPLOADS_MATCH_TABLE_HEADER_GRANT_NAME: 'Grant Name',
  DATA_UPLOADS_MATCH_TABLE_HEADER_GRANT_AMOUNT: 'Grant Amount',
  DATA_UPLOADS_MATCH_TABLE_HEADER_GOAL_AMOUNT: 'Campaign Goal',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CONTRIBUTION_ID: 'Contribution Id',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_ID: 'Constituent Id',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CAMPAIGN_ID: 'Campaign Id',
  DATA_UPLOADS_MATCH_TABLE_HEADER_INSTAGRAM_PROFILE: 'Instagram Profile',
  DATA_UPLOADS_MATCH_TABLE_HEADER_ITEM_DONATED: 'Item Contributed',
  DATA_UPLOADS_MATCH_TABLE_HEADER_ITEM_DONATED_TOOLTIP: 'For In-Kind Giving',
  DATA_UPLOADS_MATCH_TABLE_HEADER_LIFECYCLE_BOARD: 'Lifecycle Board',
  DATA_UPLOADS_MATCH_TABLE_HEADER_LIFECYCLE_BOARD_COLUMN:
    'Lifecycle Board Column',
  DATA_UPLOADS_MATCH_TABLE_HEADER_LINKED_PROFILE: 'LinkedIn Profile',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CONTRIBUTION_NOTE: 'Contribution Note',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PAYMENT_TYPE: 'Payment Method',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PAYMENT_TYPE_TOOLTIP:
    'Accepted payment methods include: cash, credit, check, wire, app, or crypto',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_BIZ: 'Phone Number Business',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_HOME: 'Phone Number Home',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_MOBILE: 'Phone Number Mobile',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_NUMBER: 'Phone Number',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_NUMBER_PRIMARY:
    'Phone Number - Primary',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_PRIMARY_BIZ:
    'Phone Number Business - Primary',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_PRIMARY_HOME:
    'Phone Number Home - Primary',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_PRIMARY_MOBILE:
    'Phone Number Mobile - Primary',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PREFIX: 'Prefix',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PRONOUNS: 'Pronouns',
  DATA_UPLOADS_MATCH_TABLE_HEADER_QUANTIFY: 'Quantity',
  DATA_UPLOADS_MATCH_TABLE_HEADER_RESTRICTION_AREA: 'Area of Restriction',
  DATA_UPLOADS_MATCH_TABLE_HEADER_SOFT_CREDIT: 'Soft Credit Email',
  DATA_UPLOADS_MATCH_TABLE_HEADER_SOFT_CREDIT_TOOLTIP:
    'Email to associate credit to',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_SOURCE: 'Constituent Source',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CAMPAIGN_SOURCE: 'Campaign Source',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CONTRIBUTION_SOURCE: 'Contribution Source',
  DATA_UPLOADS_MATCH_TABLE_HEADER_SPONSORSHIP_AMOUNT: 'Sponsorship Amount',
  DATA_UPLOADS_MATCH_TABLE_HEADER_START_DATE: 'Recurring Start Date',
  DATA_UPLOADS_MATCH_TABLE_HEADER_START_DATE_TOOLTIP:
    'Date Recurring Donation Begins',
  DATA_UPLOADS_MATCH_TABLE_HEADER_STATE: 'State/Province',
  DATA_UPLOADS_MATCH_TABLE_HEADER_TWITTER_HANDLE: 'Twitter Profile',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CAMPAIGN_WEBSITE: 'Campaign Website',
  DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_WEBSITE: 'Constituent Website',
  DATA_UPLOADS_MATCH_TABLE_HEADER_ZIP: 'Zip',
  DATA_UPLOADS_MATCH_TABLE_HEADER_DEDICATION_NAME: 'Dedicated To (Name)',
  DATA_UPLOADS_MATCH_TABLE_HEADER_DEDICATION_EMAIL: 'Dedicated To (Email)',
  DATA_UPLOADS_MATCH_TABLE_HEADER_DEDICATION_TYPE: 'Dedication Type',
  DATA_UPLOADS_MATCH_TABLE_HEADER_DEDICATION_TYPE_TOOLTIP:
    'Accepted values: in_honor, in_memory',
  DATA_UPLOADS_MATCH_TABLE_HEADER_UNIT: 'Apt/Suite',
  DATA_UPLOADS_MATCH_TABLE_HEADER_PREFERRED_FIRST_NAME: 'Preferred First Name',
  // END: table header dropdown
};
